// Source/Delivery-Choice/Component.ts
class DeliveryChoice extends HTMLElement {
  controller;
  picker;
  parts = {};
  constructor() {
    super();
    this.setupParts();
  }
  connectedCallback() {
    this.controller = new AbortController;
    this.setupListeners();
    this.setupPicker();
  }
  disconnectedCallback() {
    this.controller.abort();
  }
  setupParts() {
    const define = (part, get) => Object.defineProperty(this.parts, part, { get });
    Object.defineProperty(this.parts, "options", {
      get: () => Array.from(this.querySelectorAll(`[ name = 'delivery-preference' ]`))
    });
    define("input", () => this.querySelector(`.Delivery_Choice-Date`));
    define("drawer", () => this.closest(`cart-drawer`));
    define("form", () => this.closest("form"));
    define("overview", () => this.parts.drawer.parts.overview);
  }
  setupListeners() {
    const { signal } = this.controller;
    this.parts.options.forEach((option) => {
      option.addEventListener("click", () => {
        this.select(option.value);
      }, { signal });
    });
  }
  setupPicker() {
    const { signal } = this.controller;
    const { input } = this.parts;
    this.picker = DatePicker(input, {
      dateFormat: "Y-m-d",
      altFormat: "d.m.Y",
      noDefault: this.noDate,
      altInput: true,
      minDate: input.min,
      disable: [isWeekend],
      locale: window.FlatPickerLocale
    });
    signal.addEventListener("abort", () => this.picker.destroy());
  }
  async select(type) {
    const Selector_Preferences = `.Delivery_Choice-Types`, Selector_Date_Input = `#requested-delivery-date`;
    const container = document.querySelector(Selector_Preferences);
    const input = document.querySelector(Selector_Date_Input);
    const reset = () => this.set(type, "");
    reset();
    input.removeAttribute("error");
    input.removeAttribute("weekdays");
    input.onchange = () => {
      const { value } = input;
      if (value === "") {
        reset();
        return;
      }
      input.dataset.isEmpty = String(false);
    };
    container.removeAttribute("error");
    const noDate = type === "Sofort";
    input.dataset.hidden = String(noDate);
  }
  set(type, date) {
    const { input, form } = this.parts;
    form["delivery-preference"].value = type;
    type ||= "Sofort";
    date ||= "";
    if (type === "Sofort")
      date = "";
    const noDateRequired = type === "Sofort";
    const noDate = date === "";
    input.value = date;
    input.dataset.isEmpty = String(noDate);
    input.dataset.hidden = String(noDateRequired);
    this.dataset.noDate = String(noDate);
    const picker = this.picker;
    picker.set("noDefault", noDate);
    picker.setDate(date);
  }
  get noDate() {
    return this.dataset.noDate === "true";
  }
}
function isWeekend(date) {
  return [0, 6].includes(date.getDay());
}

// Source/Delivery-Choice/mod.ts
customElements.define("delivery-choice", DeliveryChoice);
